import { createContext, useContext } from "react";

const VoidReplacementPendingContext = createContext<ReadonlySet<string>>(
  new Set(),
);

export const VoidReplacementPendingProvider =
  VoidReplacementPendingContext.Provider;

/**
 * True while the void workflow is still creating the replacement shipment for
 * every given group, so action buttons can stay pending past the RPC returning.
 */
export function useVoidReplacementPending(groupIds: readonly string[]) {
  const pendingGroupIds = useContext(VoidReplacementPendingContext);
  return groupIds.length > 0 && groupIds.every((id) => pendingGroupIds.has(id));
}
